import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetPostLoginNotificationsParams {
}

export interface IGetPostLoginNotificationsResult extends IResult {
  contentUrl: string;
}

export class GetPostLoginNotificationsRequest
    extends Request<IGetPostLoginNotificationsParams, IGetPostLoginNotificationsResult> {

  constructor() {
    super('getPostLoginNotifications', {});
  }

}
